import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

function ClassementBarChart({ data = [] }) {
  if (!data.length) {
    return (
      <div className="flex h-[320px] items-center justify-center rounded-[1.5rem] bg-slate-50 text-sm font-bold text-slate-500 dark:bg-white/[0.03] dark:text-white/50">
        Aucun classement renseigné.
      </div>
    );
  }

  return (
    <div className="h-[340px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 12, left: -12, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" opacity={0.35} />
          <XAxis dataKey="name" tick={{ fontSize: 12 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
          <Tooltip formatter={(value) => [`${value}`, "Classements"]} />
          <Bar
            dataKey="value"
            name="Classements"
            fill="#0284c7"
            radius={[12, 12, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ClassementBarChart;